import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {
  getWeekNumber,
  turkishCurrencyFormatter,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";

export default function StockTable(props) {
  const { stocks, setNetStockAmount, reportDate, netStockAmount, type } = props;
  const [selectedStock, setSelectedStock] = useState({
    product: { _id: "", name: "", features: [] },
    totalAmount: 0,
    totalCost: 0,
  });

  useEffect(() => {
    setNetStockAmount(
      stocks.reduce((a, c) => a + (c.diffCost ? c.diffCost : 0), 0).toFixed(2)
    );
  }, [stocks, setNetStockAmount]);

  return (
    <table className="table table-bordered table-striped table-sm">
      <thead>
        <tr className="table-danger">
          <th colSpan={3} className="text-center">
            {`Net Stok / Bir Önceki ${
              type === "daily"
                ? "Güne(Kapanışa)"
                : type === "annual"
                ? "Yıla"
                : type === "weekly"
                ? "Haftaya"
                : "Aya"
            } Göre Stok Değişimi`}
          </th>
        </tr>
        <tr className="table-danger">
          <th></th>
          <th className="text-end">
            <div>Adet Cinsinden</div>
          </th>
          <th className="text-end">
            <div>Tutar Cinsinden</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {stocks.map((p) => (
          <>
            <tr key={p.product._id} className="table-danger">
              <td className="text-bold">
                {p.product.features.length > 1 && (
                  <Button
                    className="p-0 pe-1 ps-1"
                    variant="link"
                    onClick={() => {
                      if (selectedStock.product._id === p.product._id) {
                        setSelectedStock({
                          product: { _id: "", features: [] },
                        });
                      } else {
                        setSelectedStock(p);
                      }
                    }}
                  >
                    {selectedStock.product._id === p.product._id ? (
                      <i className="fa fa-minus"></i>
                    ) : (
                      <i className="fa fa-plus"></i>
                    )}
                  </Button>
                )}
                {(p.product.features.length === 1
                  ? (p.product.features[0].name
                      ? p.product.features[0].name
                      : "") + " "
                  : "") + p.product.name}
              </td>
              <td className="text-end">
                <span>{p.totalAmount}</span>
                {p.diffAmount !== 0 && (
                  <>
                    <span>/</span>

                    <span
                      className={
                        p.diffAmount > 0
                          ? "small-font text-success"
                          : "small-font text-danger"
                      }
                    >
                      {p.diffAmount ? p.diffAmount : "0"}
                    </span>
                  </>
                )}
              </td>
              <td className="text-end">
                {p.itemCost &&
                  (p.product.features.length > 1 ? false : true) && (
                    <>
                      <span className="small-font text-secondary">
                        {turkishCurrencyFormatter(p.itemCost)}
                      </span>{" "}
                      &nbsp;
                    </>
                  )}
                <span>{turkishCurrencyFormatter(p.totalCost)}</span>
                {p.diffCost !== 0 && (
                  <>
                    <span>/</span>

                    <span
                      className={
                        p.diffCost > 0
                          ? "small-font text-success"
                          : "small-font text-danger"
                      }
                    >
                      {p.diffCost ? p.diffCost.toFixed(2) : "0"}
                    </span>
                  </>
                )}
              </td>
            </tr>
            {p.product._id === selectedStock.product._id &&
              selectedStock.product.features.map((f) => (
                <tr
                  className="table-active table-info"
                  key={selectedStock.product + "" + f.feature}
                >
                  <td>
                    <i
                      className="fa fa-circle p-0 ps-2 pe-2 ms-2 mb-1 text-primary"
                      style={{
                        fontSize: "8px",
                        verticalAlign: "middle",
                      }}
                    ></i>
                    {f.feature}
                  </td>
                  <td className="text-end">
                    <span>{f.amount}</span>
                    {f.diffAmount !== 0 && (
                      <>
                        <span>/</span>

                        <span
                          className={
                            f.diffAmount > 0
                              ? "small-font text-success"
                              : "small-font text-danger"
                          }
                        >
                          {f.diffAmount ? f.diffAmount : "0"}
                        </span>
                      </>
                    )}
                  </td>
                  <td className="text-end">
                    {f.itemCost && (
                      <>
                        <span className="small-font text-secondary">
                          {turkishCurrencyFormatter(f.itemCost)}
                        </span>{" "}
                        &nbsp;
                      </>
                    )}
                    <span>{turkishCurrencyFormatterNoPrecision(f.cost)}</span>
                    {f.diffCost !== 0 && (
                      <>
                        <span>/</span>

                        <span
                          className={
                            f.diffCost > 0
                              ? "small-font text-success"
                              : "small-font text-danger"
                          }
                        >
                          {f.diffCost ? f.diffCost.toFixed(2) : "0"}
                        </span>
                      </>
                    )}
                  </td>
                </tr>
              ))}
          </>
        ))}
      </tbody>
      <tfoot>
        <tr className="table-danger text-bold">
          <td colSpan={2}>
            {netStockAmount > 0 && (
              <div className="small-font text-success">
                {(type === "daily"
                  ? reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : type === "monthly"
                  ? reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                      month: "long",
                    })
                  : type === "weekly"
                  ? `${getWeekNumber(
                      reportDate
                    )}.Hafta ${reportDate.getFullYear()}`
                  : reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                    })) +
                  "'de stoğunuz " +
                  turkishCurrencyFormatterNoPrecision(netStockAmount) +
                  " kadar artarak " +
                  turkishCurrencyFormatterNoPrecision(
                    stocks.reduce((a, p) => a + p.totalCost, 0)
                  ) +
                  " oldu!"}
              </div>
            )}
            {netStockAmount < 0 && (
              <div className="small-font text-danger">
                {(type === "daily"
                  ? reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : type === "monthly"
                  ? reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                    })
                  : type === "weekly"
                  ? `${getWeekNumber(
                      reportDate
                    )}.Hafta ${reportDate.getFullYear()}`
                  : reportDate.toLocaleDateString("tr-TR", {
                      year: "numeric",
                      month: "long",
                    })) +
                  "'de stoğunuz " +
                  turkishCurrencyFormatterNoPrecision(netStockAmount) +
                  " kadar düşerek " +
                  turkishCurrencyFormatterNoPrecision(
                    stocks.reduce((a, p) => a + p.totalCost, 0).toFixed(2)
                  ) +
                  " oldu!"}
              </div>
            )}
          </td>

          <td className="text-end">
            <span>
              {turkishCurrencyFormatterNoPrecision(
                stocks.reduce((a, p) => a + p.totalCost, 0)
              )}
            </span>
            <span
              className={netStockAmount > 0 ? "text-success" : "text-danger"}
            >
              /{netStockAmount}
            </span>
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
